import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import IntInput from "components/Input/IntInput.js";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import { getSite } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { patrimoinepage } from "variables/tertiaryBill";
import { NotificationManager } from 'react-notifications';
import { weatherstations } from "variables/lists/tertiarybill";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


export default function Patrimoine(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [tertiarybill, setTertiarybill] = useState("");

  const [idefaoperat, setIdefaoperat] = useState("");
  const [maincategory, setMaincategory] = useState("");
  const [weatherstation, setWeatherstation] = useState("");
  const [heatedsurface, setHeatedsurface] = useState("");
  const [cooledsurface, setCooledsurface] = useState("");
  const [evcount, setEvcount] = useState("");
  const [maincategorydata, setMaincategorydata] = useState([]);

  const handleIdefaoperatChange = (event) => {
    setIdefaoperat(event.target.value);
  };
  const handleMaincategoryChange = (event) => {
    setMaincategory(event.target.value);
  };
  const handleWeatherstationChange = (event) => {
    setWeatherstation(event.target.value);
  };
  const handleHeatedsurfaceChange = (event) => {
    setHeatedsurface(event.target.value);
  };
  const handleCooledsurfaceChange = (event) => {
    setCooledsurface(event.target.value);
  };
  const handleEvcountChange = (event) => {
    setEvcount(event.target.value);
  };

  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "tertiarybill"),
        {
          ...tertiarybill,
          idefaoperat,
          maincategory,
          weatherstation,
          heatedsurface,
          cooledsurface,
          evcount,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setTertiarybill(res.data.detail.tertiarybill || {});
        setIdefaoperat(res.data.detail.tertiarybill?.idefaoperat);
        setMaincategory(res.data.detail.tertiarybill?.maincategory);
        setWeatherstation(res.data.detail.tertiarybill?.weatherstation);
        setHeatedsurface(res.data.detail.tertiarybill?.heatedsurface);
        setCooledsurface(res.data.detail.tertiarybill?.cooledsurface);
        setEvcount(res.data.detail.tertiarybill?.evcount);
        let catdatatmp = [];
        if(res.data.detail.tertiarybill?.categories)
        {
          res.data.detail.tertiarybill.categories.forEach((category) => {
            if(!catdatatmp.find((data)=>data.id === category.category))
              catdatatmp.push({ id: category.category, name: category.category });
          });
        }
        setMaincategorydata(catdatatmp);
      });
  }, []);

  const classes = useStyles();

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>

          <div>
            <TextInput
              inputTitle={patrimoinepage.idefaoperat}
              textInput={idefaoperat}
              handleTextInputChange={handleIdefaoperatChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={patrimoinepage.maincategory}
              selectValue={maincategory}
              handleSelectValueChange={handleMaincategoryChange}
              disabled={!realestateupdate || (maincategorydata.length == 0)}
              data={maincategorydata}
            />
          </div>
          {
            (maincategorydata.length == 0) ? 
            <div style={{padding:"0.5rem 0 0 0.5rem"}}>{patrimoinepage.maincategorymissing}</div>
            :<></>
          }
          <div>
            <CustomSelect
              inputTitle={patrimoinepage.weatherstation}
              selectValue={weatherstation}
              handleSelectValueChange={handleWeatherstationChange}
              disabled={!realestateupdate}
              data={weatherstations}
            />
          </div>
          <div>
            <IntInput
              inputTitle={patrimoinepage.heatedsurface}
              intInput={heatedsurface}
              handleIntInputChange={handleHeatedsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={patrimoinepage.cooledsurface}
              intInput={cooledsurface}
              handleIntInputChange={handleCooledsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={patrimoinepage.evcount}
              intInput={evcount}
              handleIntInputChange={handleEvcountChange}
              disabled={!realestateupdate}
            />
          </div>

        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}
